
import { Options, Vue } from 'vue-class-component';
import { PajamasSquareMeterConfigurationClient } from '@/services/Services';
import UploadPajamasExcelModal from '../modals/uploadPajamasExcelModal.vue';
import * as OM from '@/Model';

@Options({
    components: {}
})
export default class pajamasConfig extends Vue {

    configurations: OM.PajamasSquareMeterCombinationsConfig[] = [];

    created() {
        this.init();
    }

    init() {
        PajamasSquareMeterConfigurationClient.getConfigurationList()
        .then(x => {
            this.configurations = x;
        })
    }

    uploadExcelModal() {
        this.$opModal.show(UploadPajamasExcelModal, {
            callback: () => {
                this.$opModal.closeLast();
                this.init();
            }
        })
    }

}
